import { apiDelete, apiGet, apiPost, apiPut } from '@/shared/utils/requestBuilder';
import { parseApiResponse } from '@/shared/utils/apiResponse';
import type {
  CreateWorkspaceCredentialInput,
  UpdateWorkspaceCredentialInput,
  WorkspaceCredential,
} from '../../types/workspaceCredentials';

const BASE_URL = '/admin/workspace-credentials';

export const workspaceCredentialsService = {
  async list(escritorioId: string, search?: string): Promise<WorkspaceCredential[]> {
    const query = new URLSearchParams({ escritorioId });
    if (search) query.set('search', search);
    const response = await apiGet(`${BASE_URL}?${query.toString()}`);
    return parseApiResponse<WorkspaceCredential[]>(response);
  },

  async create(data: CreateWorkspaceCredentialInput): Promise<WorkspaceCredential> {
    const response = await apiPost(BASE_URL, data);
    return parseApiResponse<WorkspaceCredential>(response);
  },

  async update(id: string, data: UpdateWorkspaceCredentialInput): Promise<WorkspaceCredential> {
    const response = await apiPut(`${BASE_URL}/${id}`, data);
    return parseApiResponse<WorkspaceCredential>(response);
  },

  async remove(id: string): Promise<void> {
    const response = await apiDelete(`${BASE_URL}/${id}`);
    if (!response.ok) {
      const error = await response.text();
      throw new Error(error || `HTTP ${response.status}`);
    }
  },
};
